import React from 'react';
import { Typography } from '@/components/common';
import { UserLastUpdated } from '@/interfaces';
import { getNameAndInitialLastName } from '@/utils';
import { format } from 'date-fns';

interface Props {
	updateInformation: UserLastUpdated | undefined;
}

export const Header: React.FC<Props> = ({ updateInformation }) => {
	return (
		<div className="flex items-center justify-between">
			<Typography type="semibold-20">Case Administration</Typography>
			{updateInformation && (
				<Typography type="regular-14">
					<span className="opacity-60">Last updated:</span>{' '}
					{format(updateInformation.last_updated_date, 'MM/dd/yyyy')}{' '}
					<span className="opacity-60">by</span>{' '}
					{getNameAndInitialLastName(updateInformation.username)}
				</Typography>
			)}
		</div>
	);
};
